exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchResults__header{align-items:flex-end;display:flex;margin-bottom:15px;min-height:30px}.searchResults__header-row{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;white-space:nowrap;width:100%}.searchResults__tiles{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}.searchResults__tile{height:100%;margin-bottom:20px;width:49%}.searchResults__author-name{font-size:1.071em;text-align:center}.searchResults__result-count{font-family:\"Bebas Neue\",\"bebas-fallback\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-size:1.286em;padding:3px 8px 0;position:relative;text-align:center;text-transform:uppercase}@media (max-width: 639px){.searchResults__tiles{padding-top:15px}.searchResults__tile{width:100%}.searchResults__header{margin-bottom:0}}\n", ""]);

// exports
exports.locals = {
	"searchResults__header": "searchResults__header",
	"searchResults__header-row": "searchResults__header-row",
	"searchResults__tiles": "searchResults__tiles",
	"searchResults__tile": "searchResults__tile",
	"searchResults__author-name": "searchResults__author-name",
	"searchResults__result-count": "searchResults__result-count"
};